<template>
  <div>
    <div v-if="fileAwsUrls && !fileNameLoaded">
      <h4 v-for="fileUrl in fileAwsUrls" :key="fileUrl.url">
        {{ extractName(fileUrl.keyName) }}
        <a class="card-title" :href="fileUrl.url" target="_blank">Revisar</a>
      </h4>
    </div>
    <h4 v-else class="card-title">{{ fileNameLoaded }}</h4>
    <div class="file-input">
      <div v-if="!fileImg">
        <div class="image-container">
          <img :src="imgDefault" title="" />
        </div>
      </div>
      <div class="image-container" v-else>
        <img :src="fileImg" />
      </div>
      <div v-if="updatable" class="button-container">
        <md-button
          class="md-danger md-round"
          @click="removeImage()"
          v-if="fileImg"
          ><i class="fa fa-times"></i>Descartar</md-button
        >
        <md-button class="md-primary md-round md-fileinput">
          <template v-if="!fileImg">{{
            fileAwsUrls.length && buttonTextUpdate
              ? buttonTextUpdate
              : buttonText
          }}</template>
          <template v-else>Cambiar</template>
          <input type="file" @change="onFileChange" />
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import Constants from "../../constants";
export default {
  name: "PictureSelect",
  props: [
    "fileName",
    "buttonText",
    "fileReason",
    "buttonTextUpdate",
    "updatable",
    "userId"
  ],

  data() {
    return {
      imgDefault: "./img/capital77/file-icon.webp",
      fileImg: null,
      fileNameLoaded: "",
      fileForm: null,
      Constants: Constants,
      fileAwsUrls: []
    };
  },
  mounted() {
    if (!this.Constants.getUserId() && !this.userId)
      this.$router.push("/login");
    else {
      this.$apollo
        .query({
          query: gql`
            query getKeyName($accOrCreditId: Int!, $reason: String!) {
              getKeyName(accOrCreditId: $accOrCreditId, reason: $reason)
            }
          `,
          variables: {
            accOrCreditId: this.userId ? this.userId : Constants.getUserId(),
            reason: this.fileReason
          }
        })
        .then(data => {
          var keyNames = data.data.getKeyName;
          if (keyNames) {
            keyNames.forEach(keyName => {
              this.$apollo
                .query({
                  query: gql`
                    query getPresignedUrl($keyName: String!) {
                      getPresignedUrl(keyName: $keyName)
                    }
                  `,
                  variables: {
                    keyName: keyName
                  }
                })
                .then(data => {
                  this.fileAwsUrls.push({
                    url: data.data.getPresignedUrl,
                    keyName
                  });
                  this.imgDefault = "./img/capital77/file-check-icon.webp";
                })
                .catch(error => {
                  //URL inválido error.message avoid propagation
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            false
          );
        });
    }
  },
  methods: {
    extractName(keyName) {
      var split = keyName.split("/");
      return split[split.length - 1];
    },
    initFileForm() {
      this.fileForm = new FormData();
      this.fileForm.set("documentValue", this.Constants.getUserDocumentValue());
      this.fileForm.set("reason", this.fileReason);
    },

    onFileChange(e) {
      this.initFileForm();
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.$emit("fileForm", this.fileForm);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      var partsName = file.name.split(".");
      var extension = partsName[partsName.length - 1];

      this.fileNameLoaded = file.name;

      if (
        extension.toLowerCase() == "jpeg" ||
        extension.toLowerCase() == "png" ||
        extension.toLowerCase() == "jpg"
      ) {
        reader.onload = e => {
          vm.fileImg = e.target.result;
          vm.fileForm.set("files", file, this.fileName + "." + extension);
        };

        reader.readAsDataURL(file);
      } else if (file.size < 5000000) {
        reader.onload = e => {
          vm.fileImg = "./img/capital77/file-check-icon.webp";
          vm.fileForm.set("files", file, this.fileName + "." + extension);
        };

        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "Tamaño no permitido",
          text: "Sólo puedes cargar archivos menores a 5 Mb",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    removeImage: function() {
      this.fileImg = "";
      this.fileNameLoaded = "";
      this.fileForm = null;
      this.$emit("fileForm", this.fileForm);
    }
  }
};
</script>

<style></style>
